module.exports = __webpack_public_path__ + "img/hokodo_2024_10_23.390450c.svg";